var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGraphicPassive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24V7.99996H12V24H10ZM15.5 29.3333V2.66663H17.5V29.3333H15.5ZM4.5 18.6666V13.3333H6.5V18.6666H4.5ZM21 24V7.99996H23V24H21ZM26.5 18.6666V13.3333H28.5V18.6666H26.5Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGraphicPassive);
export default __webpack_public_path__ + "static/media/icon-graphic-passive.2432e2e1442d399d261ff08c693d4645.svg";
export { ForwardRef as ReactComponent };